import methodClass from "./_internal/_methodClass.js";

export default methodClass("remove");
